import { getAverageRatingMerged } from 'commerce/services/reviews';
import {
  AverageRatingResponse,
  IProductForAverageReviews,
  IProductWithRefKeys,
} from './types';

export const addAverageRatingToProducts = ({
  products,
  rating,
}: {
  products?: IProductForAverageReviews[];
  rating?: AverageRatingResponse;
}): IProductForAverageReviews[] => {
  if (!products?.length) {
    return [];
  }
  if (!rating) {
    return products;
  }

  return products.map((product) => ({
    ...product,
    ratingCount: rating?.[product.id].count,
    ratingScore: rating?.[product.id].rating,
  }));
};

export const createProductsWithRefKeys = (
  products: IProductForAverageReviews[],
) => {
  return (
    products.map<IProductWithRefKeys>((product) => ({
      productId: product.id,
      referenceKeys: getReferenceKeys(product),
    })) || []
  );
};

export const getReferenceKeys = (
  product: IProductForAverageReviews,
): string[] => {
  return [
    product.referenceKey,
    ...(product?.siblings?.map(({ referenceKey }) => referenceKey) || []),
  ];
};

export const getAverageRatingForProducts = async (
  entities: IProductForAverageReviews[],
  getAverageRating: typeof getAverageRatingMerged,
): Promise<AverageRatingResponse> => {
  const products = createProductsWithRefKeys(entities);

  try {
    const responses = await Promise.all(
      products.map(({ referenceKeys }) =>
        getAverageRating(referenceKeys).catch(() => {
          return null; // Return null or a default value if there’s an error
        }),
      ),
    );

    return responses.reduce<AverageRatingResponse>((acc, item, index) => {
      if (item) {
        acc[products[index].productId] = {
          rating: item.response?.avgRating,
          count: item.response?.totalCount,
        };
      }
      return acc;
    }, {});
  } catch (error) {
    console.error(error);
    return {};
  }
};
